import React from 'react'

function ServerErrPage() {
  return (
    <div style={{width:"100vw", height:"95vh", display:"flex", alignItems:"center", justifyContent:"center"}}><img src='https://s3.amazonaws.com/smarttrak.co/images/internal-error.png' style={{width:"80%"}} /></div>
  )
}

export default ServerErrPage